import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { DataError, LoadingIndicator, Typography } from "@digital-services/ui";

import { OrganizationStatusIcon } from "@organization/components/OrganizationStatusIcon";
import { useGetOrganizationDetails } from "@organization/services/use-organization";

import { formatterShort } from "@utils/time-utils";

const OrganizationInfo: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "organization" });

  const { organization, error, isLoading } = useGetOrganizationDetails();

  if (isLoading) {
    return (
      <div className="flex w-full items-center text-base">
        <LoadingIndicator label={t("load.message")} />
      </div>
    );
  }

  if (error || organization == undefined) {
    return (
      <DataError
        title={t("load.error.message")}
        message=""
        className="text-left! text-red-600"
      />
    );
  }

  return (
    <div
      className="organization-short-description"
      data-testid="organization-short-description"
    >
      <Typography
        variant="description"
        className="mb-5 flex items-center gap-2"
      >
        <OrganizationStatusIcon status={organization?.status} />
        <span>|</span>
        <span>{t("created-on")}</span>
        <span>{formatterShort(organization.createdOn)}</span>
      </Typography>
    </div>
  );
};

export default OrganizationInfo;
